// Schéma de déverrouillage à 9 points, façon Android : on clique/tape les
// points dans l'ordre pour reconstituer le motif indiqué par le client.
// Cliquer sur un point déjà utilisé retire ce point et tous ceux ajoutés
// après lui (on ne peut pas "sauter" un point du milieu du tracé).
export function UnlockPatternPicker({ value, onChange, disabled }) {
  const schema = value || [];
  const size = 200;
  const cell = size / 3;

  const pointAt = (i) => ({ x: ((i % 3) + 0.5) * cell, y: (Math.floor(i / 3) + 0.5) * cell });

  const toggle = (idx) => {
    if (disabled) return;
    const pos = schema.indexOf(idx);
    onChange(pos === -1 ? [...schema, idx] : schema.slice(0, pos));
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <svg width={size} height={size} className="touch-none select-none" data-testid="unlock-pattern-svg">
        {schema.slice(1).map((idx, i) => {
          const a = pointAt(schema[i]);
          const b = pointAt(idx);
          return (
            <line
              key={i} x1={a.x} y1={a.y} x2={b.x} y2={b.y}
              className="stroke-primary" strokeWidth={3} strokeLinecap="round"
            />
          );
        })}
        {Array.from({ length: 9 }, (_, i) => {
          const { x, y } = pointAt(i);
          const actif = schema.includes(i);
          return (
            <g key={i} onClick={() => toggle(i)} className={disabled ? "" : "cursor-pointer"} data-testid={`unlock-pattern-point-${i}`}>
              <circle cx={x} cy={y} r={18} fill="transparent" />
              <circle cx={x} cy={y} r={actif ? 9 : 6} className={actif ? "fill-primary" : "fill-muted-foreground/40"} />
            </g>
          );
        })}
      </svg>
      {schema.length > 0 && !disabled && (
        <button type="button" onClick={() => onChange([])} className="text-xs text-muted-foreground underline" data-testid="unlock-pattern-clear">
          Effacer
        </button>
      )}
    </div>
  );
}
